const utils = require('src/utils')
import AppHeader from 'components/AppHeader'
import SubMenu from 'components/SubMenu'
import $ from 'jquery'
import { mapGetters } from 'vuex'
global.jQuery = $
window.jQuery = $

export default {
  name: 'propose-allshop-list',
  created () {
    let readMore = false
    if (this.currentPage !== null && this.currentPage >= 1) {
      readMore = 'keepload'
    }
    this.deleteProposeNotice()
    this.getShop()
    this.getTask()
    this.search(readMore)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  updated () {
    const wr = $('.wrapper')
    if (wr.height() !== 112 && wr.height() !== 207 && wr.height() < $(window).height() && this.searchCallbackFlag === true && this.shopCallbackFlag === true) {
      wr.height($(window).height())
    }
    if (window.sessionStorage.getItem('propose_list_scroll_top') && this.searchCallbackFlag === true && this.shopCallbackFlag === true) {
      const data = JSON.parse(window.sessionStorage.getItem('propose_list_scroll_top'))
      if (data['path'] === this.$router.history.current.path) {
        $(window).scrollTop(data['scrollTop'])
        // 自動スクロール後の手動スクロールイベントの発生でセッションからスクロール情報を削除する。そのためのフラグ。
        this.isScrollDoneFlag = true
      }
    }
  },
  data () {
    return {
      shopCallbackFlag: false,
      searchCallbackFlag: false,
      isScrollDoneFlag: false,
      goodPushing: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    const $win = $(window)
    $win.on('load scroll', function () {
      $('.submenu__list').removeClass('gheader-fix')
      $('.wrapper').css('margin-top', 0)
    })
    if (to.name === 'proposeDetail') {
      const savedata = {
        'path': this.$router.history.current.path,
        'scrollTop': $(window).scrollTop()
      }
      window.sessionStorage.setItem('propose_list_scroll_top', JSON.stringify(savedata))
    } else {
      window.sessionStorage.removeItem('propose_list_scroll_top')
    }
    next()
  },
  computed: {
    ...mapGetters({
      proposeTask: 'proposeTask',
      shop: 'shopDetail',
      proposes: 'proposeList',
      getNewGoodsCount: 'newGoodsCount',
      getNewGoodId: 'newGoodId',
      nextPage: 'proposeNextPage',
      currentPage: 'proposeCurrentPage'
    }),
    isMyself () {
      return this.profile.attributes['asovi-access-token'] === window.localStorage.getItem('access_token')
    },
    profileImagePath () {
      return this.profile.attributes['profile-image-path'] ? this.profile.attributes['profile-image-path'] : ''
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      const d = new Date()
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const day = d.getDate()
      const hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      const min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      const sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  components: {
    AppHeader,
    SubMenu
  },
  methods: {
    getShop: function () {
      const self = this
      const data = {}
      const callback = function () {
        self.shopCallbackFlag = true
      }
      this.$store.dispatch('SHOP_DETAIL', { id: window.localStorage.getItem('shop_id'), data: data, callback: callback })
    },
    search: function (readMore) {
      let url = null
      if (readMore) {
        url = this.$store.getters.proposeNextPage
      } else {
        this.searchCallbackFlag = false
      }
      const self = this
      const callback = function () {
        self.searchCallbackFlag = true
      }
      const data = {
        'all_shop': 'all_shop',
        'propose_status': 'adopted',
        'order': 'adopted_at desc'
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }
      this.$store.dispatch('PROPOSE_LIST_SEARCH', { url: url, data: data, callback: callback })
    },
    getProposeContent: function (proposeContent) {
      const stringMaxLength = 73
      if (proposeContent.length > stringMaxLength) {
        proposeContent = proposeContent.substring(0, stringMaxLength)
      }
      return proposeContent ? this.content(proposeContent) + '<br><span>…もっと見る</span>' : ''
    },
    getProposeProfileImagePath: function (proposeAttributes) {
      return proposeAttributes['profile-image-path'] ? proposeAttributes['profile-image-path'] : ''
    },
    getProposeImagePath: function (proposeAttributes) {
      return proposeAttributes['propose-1-image-path'] ? proposeAttributes['propose-1-image-path'] : ''
    },
    getProposeImageCount: function (proposeAttributes) {
      let count = 0
      if (proposeAttributes['propose-2-image-path']) count++
      if (proposeAttributes['propose-3-image-path']) count++
      return (count === 0) ? '' : '+' + count
    },
    goProfileDetail: function (userId) {
      window.sessionStorage.setItem('profile_detail_referrer', this.$router.history.current.path)
      this.$router.push({ path: '/profile/' + userId })
    },
    goProposeDetail: function (proposeId) {
      window.sessionStorage.setItem('propose_detail_referrer', this.$router.history.current.path)
      this.$router.push({ path: '/propose/' + proposeId })
    },
    goProposeAllshopList: function () {
      this.$router.push({ path: '/propose_allshop_list' })
    },
    goProposeAdoptList: function () {
      this.$router.push({ path: '/propose_adopt_list' })
    },
    goProposePersonalList: function (userId) {
      this.$router.push({ path: '/propose_personal_list/' + userId })
    },
    goProposeSearchList: function () {
      this.$router.push({ path: '/propose_search_list' })
    },
    getGoodClass: function (goodId) {
      return goodId ? '-on' : ''
    },
    toggleGood: function (proposeId) {
      if (!this.goodPushing) {
        this.goodPushing = true
        const goodId = this.getGoodId(proposeId)
        if (goodId) {
          const self = this
          const data = {
            propose_id: proposeId
          }
          const callback = function () {
            self.setGoodId(proposeId, '', self.getNewGoodsCount)
            self.goodPushing = false
          }
          this.$store.dispatch('GOOD_DELETE', { id: goodId, data: data, callback: callback })
        } else {
          const self = this
          const data = {
            propose_id: proposeId
          }
          const callback = function () {
            self.setGoodId(proposeId, self.getNewGoodId, self.getNewGoodsCount)
            self.goodPushing = false
          }
          this.$store.dispatch('GOOD_CREATE', { id: goodId, data: data, callback: callback })
        }
      }
    },
    getGoodId: function (proposeId) {
      for (const index in this.proposes) {
        if (this.proposes[index].id === proposeId) {
          return this.proposes[index].attributes['good-id']
        }
      }
      return ''
    },
    setGoodId: function (proposeId, goodId, goodsCount) {
      for (const index in this.proposes) {
        if (this.proposes[index].id === proposeId) {
          this.proposes[index].attributes['good-id'] = goodId
          this.proposes[index].attributes['goods-count'] = goodsCount
          break
        }
      }
    },
    proposeHelp: function () {
      const button = document.getElementById('proposeHelpModalButton')
      button.click() // モーダル表示 イベント発火
    },
    short: function () {
      if (this.proposes.length > 0) {
        return ''
      } else {
        return 'short-contents'
      }
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    handleScroll () {
      if (this.isScrollDoneFlag) {
        window.sessionStorage.removeItem('propose_list_scroll_top')
        this.isScrollDoneFlag = false
      }
    },
    getTask: function () {
      this.$store.dispatch('PROPOSE_TASK_GET')
    },
    deleteProposeNotice: function () {
      const id = window.localStorage.getItem('user_id')
      const data = {
        'user_id': id,
        'propose_status': 'adopted'
      }
      this.$store.dispatch('DELETE_PROPOSE_NOTICE', {data: data, id: id})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-adopt-list.js